function ValidationError(message, elementMessage, ...elementNames) {
    this.message = message;
    this.elementMessage = elementMessage;
    this.elementNames = elementNames;
}

ValidationError.prototype = Object.create(Object.prototype);
ValidationError.prototype.constructor = ValidationError;
ValidationError.prototype.getMessage = function() {
    return this.message;
};
ValidationError.prototype.getElementMessage = function() {
    return this.elementMessage;
};
ValidationError.prototype.getElementNames = function() {
    return this.elementNames;
};

export default ValidationError;
